import React, {useState} from 'react';
import {View, Text, TouchableOpacity} from 'react-native';
import {TransactionItem} from '../../../../../shared/models/api/eCertificatesResponsePayload';
import {numberFormatToRub} from '../../../../../shared/utils/numberFormatToRub';
import {formatDate} from '../../../../../shared/utils/formatDate';
import {useHistoryItemCardStyles} from './HistoryItemCard.style';
import {useCertificateCardStyles} from '../../../../eCertificates/components/CertificateCard/CertificateCard.style';
import {useIsDesktop} from '../../../../../shared/hooks/useIsDesktop';

interface HistoryItemCardProps extends Omit<TransactionItem, 'truId'> {}

export function HistoryItemCard({
  truName,
  typeName,
  amount,
  quantity,
  address,
  sellerDepartment,
  dateTime,
}: HistoryItemCardProps) {
  const styles = useCertificateCardStyles();

  return (
    <TouchableOpacity>
      <View style={styles.cardContainer}>
        <View style={styles.cardContent}>
          <View style={[styles.cardColumn, {flexBasis: '33%'}]}>
            <Text style={styles.columnTitle}>Наименование</Text>
            <Text style={styles.columnText}>{truName}</Text>
          </View>

          <View
            style={{
              display: 'flex',
              flexDirection: 'row',
              flexWrap: 'nowrap',
              justifyContent: 'space-between',
              width: '100%',
            }}>
            <View>
              <Text style={styles.columnTitle}>Изменение баланса</Text>
              <Text style={styles.balance}>
                {['Покупка', 'Корректировка отрицательная'].includes(typeName) ? '-' : '+'}
                {numberFormatToRub(amount * quantity)}
              </Text>
            </View>

            <View style={styles.cardColumn2}>
              <Text style={styles.columnTitle}>Кол-во (шт)</Text>
              <Text style={styles.columnText}>{quantity}</Text>
            </View>
          </View>

          <View
            style={{
              display: 'flex',
              flexDirection: 'row',
              flexWrap: 'nowrap',
              justifyContent: 'space-between',
              width: '100%',
            }}>
            <View>
              <Text style={styles.columnTitle}>Продавец</Text>
              <Text style={styles.columnText}>{sellerDepartment}</Text>
            </View>

            <View style={styles.cardColumn2}>
              <Text style={styles.columnTitle}>Дата</Text>
              <Text style={styles.columnText}>{formatDate(dateTime)}</Text>
            </View>
          </View>
        </View>
      </View>
    </TouchableOpacity>
  );
}
